import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { QueryService } from '@ngneat/query';

@Injectable({ providedIn: 'root' })
export class WebsiteConfigService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _queryService = inject(QueryService);

  getWebsiteConfig(draft?: boolean) {
    return this._queryService.use(['website-config'], () => {
      return this._httpClient.get<any>(
        `/api/globals/website-config?draft=${draft}`
      );
    });
  }

  getCategoryImages() {
    return this._queryService.use(['category-images'], () => {
      return this._httpClient.get<any>(`/api/globals/categoriesSection`);
    });
  }

  getTranslationsData() {
    return this._queryService.use(['translationsData'], () => {
      return this._httpClient.get<any>(`/api/globals/translations`);
    });
  }
}
